const miniCartInit = () => {
  const Classes = {
    body: 'panel-open-cart',
    sidebar: 'sidebar-mini-cart',
  };

  const Selector = {
    icon: document.querySelector('.header__icon--mini-cart'),
    toggle: document.querySelector('.open-cart'),
    closeBtn: document.querySelector('.closebtn'),
  };

  const toggleMiniCart = () => {
    document.body.classList.toggle(Classes.body);
  };

  [Selector.icon, Selector.toggle, Selector.closeBtn]?.forEach((element: HTMLElement) => {
    element?.addEventListener('click', (event: Event) => {
      event.stopPropagation();

      toggleMiniCart();
    });
  });

  document.addEventListener('click', (event: Event) => {
    if (event.target instanceof HTMLElement) {
      const target = event.target as HTMLElement;

      if (!target.closest(`.${Classes.sidebar}`) && document.body.classList.contains(Classes.body)) {
        toggleMiniCart();
      }
    }
  });
};

export default miniCartInit;
